import { Injectable } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';


@Injectable()
export class AlertProvider {

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController) {

  }

  toast(title: string, position: string): void {
    let toast = this.toastCtrl.create({ message: title, position: position, duration: 3000 });
    toast.present();
  }

  alert(title: string, message: string, classCss = ''): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      cssClass: classCss,
      buttons: ['Ok'],
      enableBackdropDismiss: false
    }).present();
  }

  confirm(title: string, message: string, callback: any): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: "Não", role: 'Cancel', handler: () => { console.log('Confirm:Say:No'); } },
        {
          text: "Sim",
          handler: () => {
            callback();
          }
        }
      ]
    })
      .present()
  }

  alertConfirm(title: string, message: string, callback: any): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: "OK",
          handler: () => {
            callback();
          }
        }
      ]
    })
      .present()
  }

  alertOptions(title: string, message: string, textTrue: string, TextFalse: string, callbackTrue: any, callbackFalse: any): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: TextFalse,
          handler: () => {
            callbackFalse();
          }
        },
        {
          text: textTrue,
          handler: () => {
            callbackTrue();
          }
        }
      ]
    })
      .present()
  }
}



// WEBPACK FOOTER //
// ./src/providers/alert/alert.ts